export default '00000000-0000-0000-0000-000000000000';


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/esm-browser/nil.js
// module id = 1267
// module chunks = 22